export var createSentryProp = function (sentry) { return ({
    captureException: function (ex) {
        sentry.captureException(ex);
    },
    captureMessage: function (msg) {
        sentry.captureMessage(msg);
    },
}); };
//# sourceMappingURL=sentryProp.js.map